import { UploadDataInput, uploadData } from 'aws-amplify/storage';

const storagePut = ({ key, data, options }: UploadDataInput) => uploadData({ key, data, options }).result;

export default storagePut;
